import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=1be2a4bd&scoped=true"
import script from "./Success.vue?vue&type=script&lang=ts"
export * from "./Success.vue?vue&type=script&lang=ts"
import style0 from "./Success.vue?vue&type=style&index=0&id=1be2a4bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be2a4bd",
  null
  
)

export default component.exports